import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { useGlobalContext } from "../../Context/GlobalContext";

import axios from "axios";
import Loading from "../../Extra/Loading";

const InventoryIns = ({ stationData, itemData, active }) => {
  const [stationId, setStationId] = useState(null);
  const createEntry = () => ({
    Sr_No: null,
    // station_id: stationId,
    item_id: null,
    required_qty: null,
    available_qty: null,
    defective_qty: null,
    surplus_short_qty: null,
    remarks: null,

    delete: null,
  });

  const { userData } = useGlobalContext();

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedRow, setSelectedRow] = useState(null);
  const [entries, setEntries] = useState([createEntry()]);
  const [updateData, setUpdateData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const keys = [
    "Sr No.",
    // "station_id",
    "item_id",
    "required_qty",
    "available_qty",
    "defective_qty",

    // "surplus_short_qty",
    "remarks",

    "delete",
  ];
  const inputStyle = {
    width: "110px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const selectStyle = {
    width: "130px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  useEffect(() => {
    if (userData) {
      stationData.forEach((o) => {
        if (o.station_code === userData.stn) {
          setStationId(o.station_id);
        }
      });
    }
  }, [userData, stationData]);
  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${urlPrefix}getDynamicDataForTwoDate?table_name=m_store_inventory&station_id=${stationId}`;

      const response = await axios.get(url);

      if (response.data.success === true) {
        setUpdateData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [stationId, userData]);

  useEffect(() => {
    if (!updateData || !Array.isArray(updateData)) return;

    const formattedData = updateData.map((item) => ({
      ...item,
      isEdited: false,
    }));

    setEntries(formattedData);
  }, [updateData]);
  useEffect(() => {
    if (active === "Inventory" && stationId) {
      fetchData();
    }
  }, [active, stationId, userData]);

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) =>
        i === rowIndex
          ? {
              ...row,
              [key]: value,
              isEdited: true,
            }
          : row,
      ),
    );
  };
  const addRow = () => {
    setEntries((prev) => [...prev, createEntry()]);
  };

  const removeRow = (index) => {
    setEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const editedRows = entries.filter((row) => row.isEdited);

    if (editedRows.length === 0) {
      toast.error("No changes found");
      return;
    }

    const updateRows = editedRows.filter((row) => row.inventory_id);

    const insertRows = editedRows.filter((row) => !row.inventory_id);

    try {
      if (updateRows.length) {
        const updatePayload = {
          table_name: "m_store_inventory",
          id_column: "inventory_id",
          rows: updateRows.map((entry) => ({
            inventory_id: entry.inventory_id,
            updates: {
              station_id: stationId,

              item_id: entry.item_id,
              required_qty: entry.required_qty,
              available_qty: entry.available_qty,
              defective_qty: entry.defective_qty,
              // surplus_short_qty: entry.surplus_short_qty,
              remarks: entry.remarks,

              // updated_by: userData.id,
            },
          })),
        };

        const updateRes = await fetch(`${urlPrefix}updateAllMasterDataID`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        });

        if (!updateRes.ok) {
          const err = await updateRes.json();
          throw new Error(err.message || "Update failed");
        }
      }

      if (insertRows.length) {
        const insertPayload = {
          table_name: "m_store_inventory",
          data: insertRows.map((entry) => ({
            station_id: stationId,
            item_id: entry.item_id,
            required_qty: entry.required_qty,
            available_qty: entry.available_qty,
            defective_qty: entry.defective_qty,
            // surplus_short_qty: entry.surplus_short_qty,
            remarks: entry.remarks,

            // created_by: userData.id,
          })),
        };

        const insertRes = await fetch(`${urlPrefix}insert/insertData`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(insertPayload),
        });

        if (!insertRes.ok) {
          const err = await insertRes.json();
          throw new Error(err.message || "Insert failed");
        }
      }

      toast.success("Saved successfully");

      fetchData();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
      // fetchData();
    }
  };
  return (
    <div className="container-fluid mt-3">
      {loading && <Loading />}

      <h4 className="bg-dark text-white p-2 text-center">INVENTORY </h4>
      <div className="d-flex justify-content-center">
        <select
          className="form-select-sm shadow m-2"
          style={selectStyle}
          value={stationId}
          onChange={(e) => setStationId(Number(e.target.value))}
        >
          {/* <option>Select </option>{" "} */}
          <option>select</option>
          {userData.stn &&
            stationData

              // .filter((item) => item.station_code === userData.stn)
              .map((item) => (
                <option key={item.station_id} value={item.station_id}>
                  {item.station_code}
                </option>
              ))}
        </select>

        <button className="btn btn-dark btn-sm" onClick={addRow}>
          Add Row
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead className="border table-dark  ">
            <tr className="table-">
              {keys.map((key) => (
                <th key={key}>{key.replaceAll("_", " ").toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody className="    ">
            {entries.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  onClick={() => setSelectedRow(rowIndex)}
                  style={{
                    cursor: "pointer",
                    border: selectedRow === rowIndex ? "3px solid #b69bee" : "",
                  }}
                >
                  {keys.map((key) => (
                    <td key={key} className="p-1 m-0">
                      {key === "Sr No." ? (
                        <h1 class="badge text-bg-dark p-2">{rowIndex + 1} </h1>
                      ) : key === "delete" ? (
                        !row.inventory_id ? (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeRow(rowIndex)}
                          >
                            &times;
                          </button>
                        ) : null
                      ) : key === "remarks" ? (
                        <input
                          // disabled={!!row[key]}
                          type="text"
                          className=" form-select-sm shadow"
                          style={{
                            ...inputStyle,
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "item_id" ? (
                        <select
                          // disabled={!!row[key]}
                          className="form-select-sm shadow"
                          style={{
                            ...selectStyle,
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key] ?? ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, Number(e.target.value))
                          }
                        >
                          <option value="">Select</option>

                          {itemData.map((item) => (
                            <option key={item.item_id} value={item.item_id}>
                              {item.item_name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          // disabled={!!row.inventory_id && !!row[key]}
                          type="number"
                          className=" form-select-sm shadow"
                          style={{
                            ...inputStyle,
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center">
        <button className="btn btn-success" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </div>
  );
};

export default InventoryIns;
